import { SupportedLocale } from "./constants";

export const normalizeLocale = (str: string): SupportedLocale => {
	return (str.slice(0, -2) + str.slice(-2).toUpperCase()) as SupportedLocale;
};
